import { Collections, TeamTag, TeamTagEntity } from '@uploadcam/common';
import { Firestore, getDocs } from 'firebase/firestore';
import { getCollectionRef } from '../../../../@harmony/angular';

export class GetTeamTagsInteractor {
  constructor(private readonly db: Firestore) {}

  public async execute(id: string): Promise<TeamTag[]> {
    const collection = getCollectionRef<TeamTagEntity>(
      this.db,
      Collections.TeamTags.replace('{id}', id),
    );

    const tags = await getDocs(collection);

    return tags.docs.map((doc) => {
      const data = doc.data();
      return new TeamTag(doc.id, data.name, data.isActive);
    });
  }
}
